import { useState, useEffect } from 'react';

export interface ProjectMaterial {
  id: string;
  index: string;
  name: string;
  subName: string;
  image: string;
  category: string;
  categoryColor: string;
  unit: string;
  stock: number;
  used: number;
  ordering: number;
  status: string;
  statusColor: string;
  inventoryValue: number;
}

export function useProjectMaterials() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        kpis: [
          { label: 'Tổng số vật tư', value: 156, unit: 'loại', icon: 'ri-seedling-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
          { label: 'Tổng tồn kho', value: '12.450', unit: 'đơn vị', icon: 'ri-archive-line', color: 'text-blue-500', bg: 'bg-blue-50' },
          { label: 'Đã sử dụng', value: '8.320', unit: 'đơn vị', percent: 67, icon: 'ri-hand-coin-line', color: 'text-amber-500', bg: 'bg-amber-50' },
          { label: 'Đang đặt hàng', value: '2.150', unit: 'đơn vị', percent: 17, icon: 'ri-shopping-cart-2-line', color: 'text-rose-500', bg: 'bg-rose-50' },
          { label: 'Sắp hết hàng', value: 18, unit: 'loại', percent: 12, icon: 'ri-error-warning-line', color: 'text-orange-500', bg: 'bg-orange-50' },
          { label: 'Tổng giá trị tồn kho', value: '1.250.350.000', unit: 'VND', icon: 'ri-money-dollar-circle-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
        ],
        materials: [
          { id: '1', index: '01', name: 'Cây sao đen', subName: 'Cây xanh', image: 'https://img.icons8.com/color/96/tree.png', category: 'Cây bóng mát', categoryColor: 'bg-emerald-50 text-emerald-600', unit: 'Cây', stock: 120, used: 80, ordering: 20, status: 'Bình thường', statusColor: 'bg-emerald-50 text-emerald-600', inventoryValue: 24000000 },
          { id: '2', index: '02', name: 'Cây bằng lăng tím', subName: 'Cây xanh', image: 'https://img.icons8.com/color/96/flower.png', category: 'Cây bóng mát', categoryColor: 'bg-emerald-50 text-emerald-600', unit: 'Cây', stock: 250, used: 150, ordering: 50, status: 'Bình thường', statusColor: 'bg-emerald-50 text-emerald-600', inventoryValue: 62500000 },
          { id: '3', index: '03', name: 'Cỏ nhung nhật', subName: 'Cây xanh', image: 'https://img.icons8.com/color/96/grass.png', category: 'Cỏ', categoryColor: 'bg-emerald-50 text-emerald-600', unit: 'm²', stock: 1200, used: 800, ordering: 200, status: 'Bình thường', statusColor: 'bg-emerald-50 text-emerald-600', inventoryValue: 36000000 },
          { id: '4', index: '04', name: 'Phân hữu cơ vi sinh', subName: 'Vật tư chăm sóc', image: 'https://img.icons8.com/color/96/fertilizer.png', category: 'Phân bón', categoryColor: 'bg-blue-50 text-blue-600', unit: 'Bao (25kg)', stock: 350, used: 210, ordering: 100, status: 'Sắp hết', statusColor: 'bg-orange-50 text-orange-600', inventoryValue: 17500000 },
          { id: '5', index: '05', name: 'Đất trồng hữu cơ', subName: 'Vật tư trồng trọt', image: 'https://img.icons8.com/color/96/soil.png', category: 'Đất trồng', categoryColor: 'bg-amber-50 text-amber-600', unit: 'm³', stock: 180, used: 120, ordering: 40, status: 'Bình thường', statusColor: 'bg-emerald-50 text-emerald-600', inventoryValue: 21600000 },
        ],
        lowStockItems: [
          { id: '1', name: 'Phân hữu cơ vi sinh', stock: 15, unit: 'bao', percent: 15 },
          { id: '2', name: 'Đất trồng hữu cơ', stock: 20, unit: 'm³', percent: 40 },
          { id: '3', name: 'Dây cáp điện 2x2.5', stock: 60, unit: 'm', percent: 45 },
          { id: '4', name: 'Chậu composite tròn', stock: 5, unit: 'cái', percent: 25 },
          { id: '5', name: 'Đèn năng lượng mặt trời', stock: 8, unit: 'cái', percent: 40 },
        ],
        pendingOrders: [
          { id: '1', code: 'PO-2024-015', name: 'Ống tưới nhỏ giọt 16mm', qty: '750 m', status: 'Đang giao hàng', date: '20/05/2024', statusColor: 'text-emerald-600' },
          { id: '2', code: 'PO-2024-016', name: 'Cây sao đen', qty: '20 cây', status: 'Đã xác nhận', date: '18/05/2024', statusColor: 'text-blue-600' },
          { id: '3', code: 'PO-2024-017', name: 'Phân hữu cơ vi sinh', qty: '100 bao', status: 'Đang xử lý', date: '17/05/2024', statusColor: 'text-amber-600' },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
